import { render, staticRenderFns } from "./declaration_preview.vue?vue&type=template&id=55dafc21&"
import script from "./declaration_preview.vue?vue&type=script&lang=js&"
export * from "./declaration_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports